<!-->┌──────────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│                                      Date DMY                                        │<- ->
<- ->└──────────────────────────────────────────────────────────────────────────────────────┘<--->
<template>
    <label class="date-DMY">
        <span class="title" v-if="$slots.default"><slot></slot></span>

        <select class="DD" v-model="DD" v-bind:disabled="disabled"><option /><option v-for="dd in DDs">{{ dd }}</option></select>
        <select class="MM" v-model="MM" v-bind:disabled="disabled"><option /><option v-for="mm in MMs">{{ mm }}</option></select>
        <select class="YY" v-model="YY" v-bind:disabled="disabled"><option /><option v-for="yy in YYs">{{ yy }}</option></select>
    </label>
</template>
<script>
    export default {
        name: "DateDMY",

        props: {
            value: [String, Number, Date],
            disabled: Boolean,
            future: Boolean,
            yearRange: {
                type: Number,
                default: 120
            }
        },

        data() {
            //  Start with blank strings - not nulls - so initial blank option will be selected at startup
            return {
                DD: '',
                MM: '',
                YY: ''
            }
        },

        mounted() {
            this.date = this.value
        },

        computed: {
            date: {
                get() {
                    let [DD, MM, YY] = [this.DD, this.MM_Value, this.YY]
                    let noDate = [DD, MM, YY].filter(x => !x).length > 0
                    let date = noDate ? null : new Date(YY, MM - 1, DD)

                    //  Calculate new date based on format originally provided; default to a regular JS Date
                    switch (typeof this.value) {
                        case 'string':
                            let [dd, mm] = [DD, MM].map(v => `0${v}`.slice(-2))

                            //  Note: new Date(<this result>) will be in browser time, not UTC time
                            return noDate ? '' : `${YY}-${mm}-${dd}`

                        case 'number':
                            return noDate ? 0 : date.getTime()

                        default:
                            return date
                    }
                },

                set(date) {
                    if (!date)
                        this.DD = this.MM = this.YY = ''
                    else {
                        if (typeof date == 'string' && !date.includes('T'))
                            date += ' '

                        if (!(date instanceof Date))
                            date = new Date(date)

                        this.DD = `${date.getDate()}`
                        this.MM = date.toLocaleString(this.locale, { month: 'short' })
                        this.YY = `${date.getFullYear()}`
                    }
                }
            },

            locale() {
                return Intl.DateTimeFormat().resolvedOptions().locale
            },

            MM_Value() {
                return this.MMs.indexOf(this.MM) + 1
            },

            DDs() {
                //  Note that we're using a Vue shortcut that treats a number as if it was an array [1,...,N]
                switch (this.MM_Value) {
                    case 9, 4, 6, 11: return 30
                    case 2: return (this.YY % 4) ? 28 : 29
                    default: return 31
                }
            },

            MMs() {
                return [...Array(12)].map((_, a) => new Date(1900, a, 1).toLocaleString(this.locale, { month: 'short' }))
            },

            YYs() {
                let thisYear = new Date().getFullYear()
                let range = [...Array(this.yearRange)]

                return this.future ? range.map((_, a) => thisYear + a) : range.map((_, a) => thisYear - a)
            }
        },

        watch: {
            //  Don't allow an invalid day-of-month, based on the month and leap years
            DDs(newMaxDate) {
                if (this.DD > newMaxDate)
                    this.DD = null
            },

            //  Don't allow an invalid year if someone changes the years allowed
            YYs(newYYs) {
                if (!newYYs || newYYs.indexOf(this.YY) == -1)
                    this.YY = null
            },

            date(newDate, oldDate) {
                if (`${newDate}` != `${oldDate}`) {
                    this.$emit('input', newDate)
                }
            }
        }
    }
</script>
